// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__168Y9","footer":"ModalCreateQualiphyProcedure_footer__3Qe8X","additionData":"ModalCreateQualiphyProcedure_additionData__1vWeg"};